import React, { memo } from 'react'
import { CheckInCircle } from '../images/svg/check-in-circle'
import { MinusInCircle } from '../images/svg/minus-in-circle'
import Button from './Button'

const PriceCard = ({ price, pricePlan }) => {
  const priceValue = pricePlan?.toLowerCase()?.includes('monthly')
    ? price?.price_per_month_monthly
    : price?.price_per_month

  return (
    <div className="price-card">
      <p className="price-card-title">{price.title}</p>
      <p className="price-card-price">
        {priceValue}
        <span>{price.per_month_text}</span>
      </p>
      <Button data={price} />
      <p className="price-card-list-title">{price.included_title}</p>
      <ul className="price-card-list">
        {price?.included?.map((item) => {
          const included = item?.included1
          return (
            <li className="price-card-list-item" key={item}>
              {included ? <CheckInCircle /> : <MinusInCircle />}
              <p
                className={`price-card-list-item__title ${
                  !included ? 'included' : ''
                }`}
              >
                {item?.included_text}
              </p>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default memo(PriceCard)
